var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoTable = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15.584,
    viewBox: "0 0 16 15.584",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44923",
    "data-name": "Group 44923",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46154",
    "data-name": "Group 46154",
    transform: "translate(1 1)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49768",
    "data-name": "Path 49768",
    d: "M16,3.556l-.219,0H0c0-.14,0-.268,0-.4A12.441,12.441,0,0,1,.04,1.835,2.185,2.185,0,0,1,2.156,0Q8,0,13.842,0a2.218,2.218,0,0,1,2.124,1.815A1.078,1.078,0,0,0,16,1.934Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18763",
    "data-name": "Rectangle 18763",
    width: 4.445,
    height: 3.126,
    transform: "translate(11.555 4.445)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19488",
    "data-name": "Rectangle 19488",
    width: 4.445,
    height: 3.126,
    transform: "translate(11.555 8.452)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_19491",
    "data-name": "Rectangle 19491",
    d: "M0,0H4.445a0,0,0,0,1,0,0V0A3.126,3.126,0,0,1,1.319,3.126H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(11.555 12.459)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18765",
    "data-name": "Rectangle 18765",
    width: 5.111,
    height: 3.102,
    transform: "translate(5.556 4.445)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19489",
    "data-name": "Rectangle 19489",
    width: 5.111,
    height: 3.102,
    transform: "translate(5.556 8.452)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19492",
    "data-name": "Rectangle 19492",
    width: 5.111,
    height: 3.102,
    transform: "translate(5.556 12.459)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18767",
    "data-name": "Rectangle 18767",
    width: 4.445,
    height: 3.099,
    transform: "translate(.001 4.445)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19490",
    "data-name": "Rectangle 19490",
    width: 4.445,
    height: 3.099,
    transform: "translate(.001 8.452)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_19493",
    "data-name": "Rectangle 19493",
    d: "M0,0H4.445a0,0,0,0,1,0,0V3.1a0,0,0,0,1,0,0H3a3,3,0,0,1-3-3V0A0,0,0,0,1,0,0Z",
    transform: "translate(.001 12.459)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoTable);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_table.e8921c737c9a727bf99af1895796d49e.svg";